import { Component, Input } from '@angular/core';
import { BUTTON_CONTAINER_ALIGNMENT } from './button-container-alignment.enum';
import { BUTTON_CONTAINER_JUSTIFICATION } from './button-container-justification.enum';
import { BUTTON_CONTAINER_SPACING } from './button-container-spacing.enum';

@Component({
	selector: 'ea-button-container',
	templateUrl: './button-container.component.html',
	styleUrls: ['./button-container.component.scss']
})
export class ButtonContainerComponent {
	@Input() alignment = BUTTON_CONTAINER_ALIGNMENT.Horizontal;
	@Input() justification = BUTTON_CONTAINER_JUSTIFICATION.Fill;
	@Input() showBorder = false;
	@Input() spacing = BUTTON_CONTAINER_SPACING.Large;
	BUTTON_CONTAINER_SPACING = BUTTON_CONTAINER_SPACING;
	BUTTON_CONTAINER_ALIGNMENT = BUTTON_CONTAINER_ALIGNMENT;
	BUTTON_CONTAINER_JUSTIFICATION = BUTTON_CONTAINER_JUSTIFICATION;
}
